<div class="w-full">
	<div class="flex justify-content-center align-items-center" style="height: 30vh;" *ngIf="!loaded">
		<p-progressSpinner ariaLabel="loading" />
	</div>

	<form [formGroup]="formCourse" style="max-height: 50vh; overflow-y: auto;" *ngIf="loaded">
		<div class="flex flex-column gap-3">
			<!-- Título -->
			<div class="flex flex-column" style="width: 100%;">
				<label class="font-semibold">Título *</label>
				<input
					pInputText
					formControlName="title"
					placeholder="Ex: Introdução ao processo Licitatório"
					style="width: 100%;"
					[class.ng-invalid]="formCourse.get('title')?.invalid && formCourse.touched"
					[class.ng-dirty]="formCourse.get('title')?.dirty"
				/>
				<small class="p-error" *ngIf="titleError">{{ titleError }}</small>
			</div>

			<!-- Professor e Preço -->
			<div class="flex gap-2">
				<div class="flex flex-column" style="width: 100%;">
					<label class="font-semibold">Professor *</label>
					<p-dropdown
						[options]="listTeachers"
						optionLabel="name"
						optionValue="id"
						placeholder="Selecione o professor"
						formControlName="teacherId"
						appendTo="body"
						[style]="{width:'100%'}"
						[ngClass]="{'ng-invalid ng-dirty': formCourse.get('teacherId')?.invalid && formCourse.touched}"
					></p-dropdown>
					<small class="p-error" *ngIf="teacherIdError">{{ teacherIdError }}</small>
				</div>

				<div class="flex flex-column" style="width: 100%;">
					<label class="font-semibold">Preço *</label>
					<p-inputNumber
						placeholder="R$0,00"
						formControlName="price"
						locale="pt-BR"
						mode="currency"
						currency="BRL"
						[ngClass]="{'ng-invalid ng-dirty': formCourse.get('price')?.invalid && formCourse.touched}"
					></p-inputNumber>
					<small class="p-error" *ngIf="priceError">{{ priceError }}</small>
				</div>
			</div>

			<!-- Descrição e Curso Público -->
			<div class="flex gap-2">
				<div class="flex flex-column" style="width: 100%;">
					<label class="font-semibold">Descrição *</label>
					<textarea
						pInputTextarea
						rows="3"
						placeholder="Curso de 8h de introdução a todas as etapas do processo licitatório"
						formControlName="description"
						style="resize: none; width: 25vw;"
						class="py-2 h-full"
						[ngClass]="{'ng-invalid ng-dirty': formCourse.get('description')?.invalid && formCourse.touched}"
					></textarea>
					<small class="p-error" *ngIf="descriptionError">{{ descriptionError }}</small>
				</div>

				<div class="flex flex-column gap-1">
					<b style="text-align: center;">Curso Público</b>
					<p-selectButton
						[options]="isPublicOptions"
						class="selectType"
						[allowEmpty]="false"
						formControlName="isPublic"
					></p-selectButton>
				</div>
			</div>
		</div>
	</form>

	<!-- Botões de ação -->
	<div class="flex justify-content-end" style="margin-top: 2rem;" *ngIf="loaded">
		<p-button
			label="Criar Curso"
			icon="pi pi-check"
			class="createButton"
			[disabled]="!isFormValid || submitting"
			[loading]="submitting"
			(onClick)="CreateCourse()"
		></p-button>
	</div>
</div>
